// Please do not add anything to this file which is not a real clearchoice field
export const AFFILIATE_REF = 'affref';
export const GCLID = 'gclid';
export const LOAN_AMOUNT = 'loanAmount';
export const LOAN_TERM = 'loanTerm';